import { BackInStockConfiguration } from '../../helpers/BackInStockConfiguration';
import { CustomHeaderPolicy } from './CustomHeaderPolicy';
const headerName = 'x-tenant-context';
export const tenantPolicy = () => ({
    create: (nextPolicy, options) => {
        const { tenant } = BackInStockConfiguration.get();
        return new CustomHeaderPolicy(nextPolicy, options, headerName, tenant);
    },
});
